/**
 * @Description 竞合关系-单选筛选（用于关注品牌列表）
 * 全部=不筛选，其他选项按竞合关系过滤，单选且默认全部
 * 复用 MoreTabs 的样式与交互，避免重复维护一套 tabs 样式
 */
import { FC } from 'react';
import MoreTabs from '@/common/components/business/MoreTabs';

export const COMPETITION_ALL = 'all';

export const competitionSingleOptions = [
  { name: '全部', id: COMPETITION_ALL },
  { name: '竞争', id: 1 },
  { name: '协同', id: 2 },
  { name: '一般', id: 3 },
];

const CompetitionFilter: FC<{
  onChange: (value: string | number) => void;
}> = ({ onChange }) => {
  return (
    <MoreTabs
      tabs={competitionSingleOptions}
      tabName='name'
      tabId='id'
      className='mb-8'
      onChange={(target) => onChange(target?.id ?? COMPETITION_ALL)}
    />
  );
};

export default CompetitionFilter;
